import numeral from 'numeral';
var getTitle = filters => {
  var pattern = '$0[.]0[0]a';
  var min = filters.price && filters.price.min || 0;
  var max = filters.price && filters.price.max || 0;
  if (min || max) {
    var prefix = '';
    if (min && !max) {
      prefix = 'From';
    } else if (!min && max) {
      prefix = 'Up to';
    }
    var titleContents = [];
    if (prefix) {
      titleContents.push(prefix);
    }
    if (min) {
      titleContents.push(numeral(min).format(pattern));
    }
    if (min && max) {
      titleContents.push('-');
    }
    if (max) {
      titleContents.push(numeral(max).format(pattern));
    }
    return titleContents.join(' ');
  }
  return 'Price';
};
var buildPriceRangeProps = (filters, priceRanges, onChange) => ({
  priceRanges,
  selectedRange: filters.price || {},
  onChange
});
export default buildPriceRangeProps;
export { getTitle as getPriceRangeTitle };